/* DillySocks — Warenkorb-Drawer-Extras:
   Artikel-Zähler als Indigo-Kreis neben dem Titel "Warenkorb".
   Wird per JS in Shopifys Drawer eingefügt und bei jeder Warenkorb-
   Änderung aktualisiert — KEINE Änderung an Shopify-Dateien nötig.
   Horizon rendert den Drawer-Inhalt bei Updates neu; ein MutationObserver
   fügt den Zähler danach einfach wieder ein.

   Cleanup 10.09.2026: Die alte JS-Freebar (Gratisversand-Balken) ist
   entfernt — der Balken kommt seit dem Upsell-System serverseitig aus
   snippets/ds-goodie-bar.liquid (Metaobject cart_goodie, markt-exakte
   Schwellen) und haelt sich per Section Rendering selbst aktuell. Die
   .ds-freebar-CSS-Klassen bleiben, die Goodie-Bar nutzt sie weiter. */
(function () {
  'use strict';

  function ensureCount(drawer, cart) {
    var header = drawer.querySelector('.theme-drawer__header');
    if (!header) return;
    var title = header.querySelector('.theme-drawer__title');
    var count = header.querySelector('.ds-cart-count');
    if (title && !count) {
      count = document.createElement('span');
      count.className = 'ds-cart-count';
      title.insertAdjacentElement('afterend', count);
    }
    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }
  }

  var pending = null;
  var refreshTimer = null;
  var mo = null; /* Drawer-MutationObserver — Referenz fuer takeRecords() */
  function refresh() {
    if (pending) return;
    pending = fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pending = null;
        var drawer = document.getElementById('cart-drawer');
        if (drawer) ensureCount(drawer, cart);
        /* Eigene DOM-Schreibzugriffe sofort aus der Observer-Queue
           verwerfen — sonst triggert jeder refresh den naechsten
           (Selbstantrieb; Dauerfeuer auf /cart.js, Theresa-Report 28.08.). */
        if (mo) mo.takeRecords();
      })
      .catch(function () { pending = null; });
  }
  /* Gebuendelt statt pro Mutation: Horizon feuert beim Re-Rendern viele
     Mutationen hintereinander — ein einzelner nachgelagerter refresh reicht. */
  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 150);
  }

  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    refresh();
    /* Horizon ersetzt den Drawer-Inhalt bei jeder Warenkorb-Änderung —
       danach den Zaehler wieder einfügen/aktualisieren.
       WICHTIG (Bugfix Sean 26.08.): Der Zaehler haengt am Drawer-TITEL, den
       es im leeren Warenkorb gar nicht gibt — den Zaehler nur einfordern,
       wenn im HEADER ein Titel existiert, sonst Endlosschleife auf
       /cart.js (355 Requests/Seitenaufruf, gemessen 26.08.). */
    mo = new MutationObserver(function () {
      var head = drawer.querySelector('.theme-drawer__header');
      var needCount = head && head.querySelector('.theme-drawer__title') && !head.querySelector('.ds-cart-count');
      if (needCount) {
        refreshSoon();
      }
    });
    mo.observe(drawer, { childList: true, subtree: true });
    /* Beim Öffnen zusätzlich aktualisieren (deckt Preisänderungen ab) */
    new MutationObserver(function () { refreshSoon(); }).observe(
      drawer.querySelector('dialog') || drawer,
      { attributes: true, attributeFilter: ['open'] }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- /cart: Empfehlungs-Carousel absichern (Sean 01.09. Runde 3) --------
   "Andere Kund:innen kauften auch" wird von product-recommendations.js
   nachgeladen und per morphSection in die bestehende Section gemorpht.
   Landet der Inhalt in einer bereits initialisierten slideshow-component,
   kennt deren interner Zustand die neuen Slides nicht — Pfeile und Snap
   bleiben tot. Sobald echte Slides da sind, ersetzen wir das Element
   einmalig durch einen Klon: der Custom-Element-Upgrade laeuft frisch und
   initialisiert mit allen Slides. (Passiert einmal beim Laden, bevor
   jemand interagiert; auf der PDP ist die Section nicht betroffen.) */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-cart')) return;
  var sec = document.querySelector('.shopify-section[id*="ds_cart_reco"]');
  if (!sec) return;
  var done = false;
  function fix() {
    if (done) return;
    var ss = sec.querySelector('slideshow-component');
    if (!ss || ss.querySelectorAll('slideshow-slide').length < 2) return;
    done = true;
    mo.disconnect();
    setTimeout(function () {
      var fresh = ss.cloneNode(true);
      ss.replaceWith(fresh);
    }, 150);
  }
  var mo = new MutationObserver(fix);
  mo.observe(sec, { childList: true, subtree: true });
  fix();
})();

/* ---- Drawer-Scroll-Keeper (Kundenreport R. Froehlich 09.09.) ----------
   Jedes Hinzufuegen rendert den Drawer per Section-Morph neu; dabei kann
   die Scroll-Position der Liste auf 0 zurueckspringen — auf dem iPhone
   "verschwinden" damit alle Zeilen unterhalb des ersten Viewports
   (sichtbar bleiben nur ~3). Wir merken uns die letzte Scroll-Position
   der beiden Drawer-Scroller (scroll bubbelt nicht -> Capture) und
   stellen sie nach Mutationen wieder her, wenn sie frisch war und der
   Scroller unerwartet auf 0 steht. Beim Schliessen wird vergessen, damit
   ein Neu-Oeffnen wie gewohnt oben beginnt. */
(function () {
  'use strict';
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  var lastTops = { content: 0, items: 0 };
  var lastAt = 0;

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !drawer.contains(t)) return;
    if (t.classList.contains('cart-drawer__content')) { lastTops.content = t.scrollTop; lastAt = Date.now(); }
    else if (t.classList.contains('cart-drawer__items')) { lastTops.items = t.scrollTop; lastAt = Date.now(); }
  }, true);

  function restore() {
    if (Date.now() - lastAt > 15000) return;
    ['content', 'items'].forEach(function (k) {
      var el = drawer.querySelector('.cart-drawer__' + k);
      if (el && lastTops[k] > 40 && el.scrollTop === 0 && el.scrollHeight > el.clientHeight + 40) {
        el.scrollTop = Math.min(lastTops[k], el.scrollHeight - el.clientHeight);
      }
    });
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; restore(); }, 90);
  }).observe(drawer, { childList: true, subtree: true });

  /* Schliessen = Position vergessen (Dialog-open-Attribut beobachten) */
  var dlg = drawer.querySelector('dialog');
  if (dlg) {
    new MutationObserver(function () {
      if (!dlg.open) { lastTops.content = 0; lastTops.items = 0; lastAt = 0; }
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
  }
})();

/* ---- Sticky-Summary-Nachfuehrung (2. Teil Kundenreport R. Froehlich) ----
   Horizon entscheidet nur beim OEFFNEN und bei Cart-Updates, ob die Summary
   sticky bleibt (Summary < 50% der Drawer-Hoehe) oder in den Fluss wandert.
   Die Wallet-Buttons (Shop Pay/Apple Pay/PayPal/G Pay) hydratisieren aber
   asynchron NACH dieser Messung und blaehen die Summary auf — der Drawer
   bleibt faelschlich sticky und quetscht die Artikelliste auf ein Mini-
   Fenster (auf dem iPhone: "nur noch 3 Zeilen sichtbar"). Wir spiegeln
   Horizons eigene Formel (cart-drawer.js, #summaryThreshold = 0.5) und
   fuehren sie per ResizeObserver nach, sobald Summary oder Dialog ihre
   Groesse aendern. morph.js bewahrt das Attribut bei Re-Renders.
   WICHTIG: gemessen wird gegen den VISUAL VIEWPORT, nicht die Dialog-
   Hoehe — der Dialog ist 100vh hoch, auf dem iPhone ragt davon aber ein
   Teil hinter Safaris Leisten (874pt Dialog vs ~700pt sichtbar). Horizons
   eigene Messung faellt dadurch knapp UNTER die Schwelle, obwohl die
   Summary real ~60% des sichtbaren Drawers frisst. */
(function () {
  'use strict';
  var drawer = document.getElementById('cart-drawer');
  if (!drawer || !('ResizeObserver' in window)) return;

  var scheduled = false;
  function update() {
    scheduled = false;
    var dialog = drawer.querySelector('.theme-drawer__dialog');
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (!dialog || !summary) return;
    var dh = dialog.getBoundingClientRect().height;
    if (window.visualViewport && window.visualViewport.height) {
      dh = Math.min(dh, window.visualViewport.height);
    }
    if (!dh) return; /* Drawer zu / unsichtbar — nichts ueberschreiben */
    var ratio = summary.getBoundingClientRect().height / dh;
    dialog.setAttribute('cart-summary-sticky', ratio > 0.5 ? 'false' : 'true');
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  var ro = new ResizeObserver(schedule);
  var watched = { dialog: null, summary: null };
  function watch() {
    var dialog = drawer.querySelector('.theme-drawer__dialog');
    var summary = drawer.querySelector('.cart-drawer__summary');
    if (dialog === watched.dialog && summary === watched.summary) return;
    ro.disconnect();
    watched.dialog = dialog;
    watched.summary = summary;
    if (dialog) ro.observe(dialog);
    if (summary) ro.observe(summary);
  }
  watch();
  /* Re-Renders koennen Summary/Dialog-Knoten ersetzen — Beobachtung nachziehen */
  new MutationObserver(function () { watch(); }).observe(drawer, { childList: true, subtree: true });
  /* Safari-Leisten kollabieren/erscheinen beim Scrollen — neu bewerten */
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
  }
})();
